import './types'

import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/download',
  },

  {
    path: '/download',
    name: 'Download',
    component: () => import('@/views/download/index.vue'),
    meta: {
      title: 'App下载',
    },
  },
  {
    path: '/onlooker',
    name: 'Onlooker',
    component: () => import('@/views/onlooker/index.vue'),
    meta: {
      title: '邀请围观',
    },
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/phonecode',
    name: 'Phonecode',
    component: () => import('@/views/phonecode/index.vue'),
    meta: {
      title: '登录验证',
    },
  },
  {
    path: '/edit_face',
    name: 'EditFace',
    component: () => import('@/views/edit_face/index.vue'),
    meta: {
      title: '设置头像',
      login: true,
    },
  },
  {
    path: '/edit_nickname',
    name: 'EditNickname',
    component: () => import('@/views/edit_nickname/index.vue'),
    meta: {
      title: '设置昵称',
      login: true,
    },
  },
  {
    path: '/privacy_policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/privacy_policy/index.vue'),
    meta: {
      title: '隐私政策',
    },
  },
  {
    path: '/user_agent',
    name: 'UserAgent',
    component: () => import('@/views/user_agent/index.vue'),
    meta: {
      title: '服务协议',
    },
  },

  {
    path: '/clearcookie',
    name: 'Clearcookie',
    component: () => import('@/views/clearcookie/index.vue'),
    meta: {
      title: '清除缓存',
    },
  },

  {
    path: '/nogp',
    name: 'NotFoundGroup',
    component: () => import('@/views/Error/NotFound/group.vue'),
    meta: {
      title: '找不到群了',
    },
  },

  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/Error/NotFound/index.vue'),
    meta: {
      title: 'NotFound',
    },
  },

  {
    // https://next.router.vuejs.org/zh/guide/essentials/history-mode.html#caveat
    path: '/:pathMatch(.*)',
    redirect: '/404',
  },
]

export default routes
